"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverOnboarding = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../Icon/icons/IconX/index.js");
var _CloseButton = require("../Popover/CloseButton.js");
var _Popover = require("../Popover/Popover.js");
var _Title = require("../Popover/Title.js");
var _Body = require("./Body.js");
var _Footer = require("./Footer.js");
var _excluded = ["id", "left", "top", "right", "bottom", "popoverTitle", "onClose", "children", "paginationText", "navStepper", "footerButton", "colorSet", "className", "closeButtonAriaLabel", "closeButtonRef"];
var PopoverOnboardingComponent = /*#__PURE__*/_react["default"].forwardRef(function PopoverOnboardingComponent(_ref, ref) {
  var id = _ref.id,
    left = _ref.left,
    top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    popoverTitle = _ref.popoverTitle,
    onClose = _ref.onClose,
    children = _ref.children,
    paginationText = _ref.paginationText,
    navStepper = _ref.navStepper,
    footerButton = _ref.footerButton,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    className = _ref.className,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Close' : _ref$closeButtonAriaL,
    closeButtonRef = _ref.closeButtonRef,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var titleId = id && "".concat(id, "-title");
  var bodyId = id && "".concat(id, "-body");
  if (!(popoverTitle && id)) {
    /* eslint-disable-next-line no-console */
    console.warn('Warning: The PopoverOnboarding component must have popoverTitle and an id to be accessible.');
  }
  if (paginationText && navStepper) {
    /* eslint-disable-next-line no-console */
    console.warn('Warning: The paginationText and navStepper props are not intended to be used together. Use paginationText to maintain accessibility.');
  }
  return /*#__PURE__*/_react["default"].createElement(_Popover.Popover, Object.assign({
    ref: ref,
    id: id,
    role: "dialog",
    style: {
      left: left,
      top: top,
      right: right,
      bottom: bottom
    },
    $paddedBody: !!(onClose && !popoverTitle),
    className: (0, _classnames["default"])((0, _index.textClass)('bodySmall'), (0, _index.addColorSet)(colorSet, className)),
    $colorSet: colorSet,
    "aria-labelledby": titleId,
    "aria-describedby": bodyId
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.PopoverOnboarding
  }), popoverTitle && /*#__PURE__*/_react["default"].createElement(_Title.Title, {
    id: titleId
  }, popoverTitle), /*#__PURE__*/_react["default"].createElement(_Body.Body, {
    id: bodyId
  }, children), onClose && /*#__PURE__*/_react["default"].createElement(_CloseButton.CloseButton, {
    onClick: onClose,
    "aria-label": closeButtonAriaLabel,
    iconOnly: _index2.IconX,
    type: "button",
    ref: closeButtonRef
  }), /*#__PURE__*/_react["default"].createElement(_Footer.Footer, null, paginationText && /*#__PURE__*/_react["default"].createElement("div", null, paginationText), navStepper && /*#__PURE__*/_react["default"].createElement("div", null, navStepper), /*#__PURE__*/_react["default"].createElement("div", null, footerButton)));
});

/**
 * A popover modal used in onboarding, and can be multi-step using NavStepper.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-popoveronboarding--docs) |
 * [Encore site](https://encore.spotify.net/web/components/popover#onboarding-popover) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverOnboarding)
 */
var PopoverOnboarding = exports.PopoverOnboarding = Object.assign(PopoverOnboardingComponent, _index.deprecatedOverlayDirections);